import axios from 'axios';

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://natoure-backend.fly.dev/api'
      : 'http://localhost:8080/api',
  withCredentials: true,
});

export default instance;
